import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import {
  InputWithLabel,
  PrimaryButton,
  TextInput,
} from "@normasteaching/norma-ui";

export type NoInvoiceMoneyTransferFormParams = {
  email: string;
  firstName: string;
  lastName: string;
};

export function NoInvoiceMoneyTransferForm({
  onSubmit,
}: {
  onSubmit: (data: NoInvoiceMoneyTransferFormParams) => Promise<void>;
}) {
  const schema = yup.object({
    email: yup
      .string()
      .email("Specifica un'email valida")
      .required("Inserisci un'email"),
    firstName: yup.string().required("Inserisci il tuo nome"),
    lastName: yup.string().required("Inserisci il tuo cognome"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<NoInvoiceMoneyTransferFormParams>({
    resolver: yupResolver(schema),
  });
  const [creatingPaymentIntent, setCreatingPaymentIntent] = useState(false);

  async function submitForm(data: NoInvoiceMoneyTransferFormParams) {
    try {
      setCreatingPaymentIntent(true);
      await onSubmit(data);
    } finally {
      setCreatingPaymentIntent(false);
    }
  }

  return (
    <form className={"flex flex-col space-y-4"}>
      <InputWithLabel label={"Nome"}>
        <TextInput
          errorMessage={errors.firstName?.message}
          {...register("firstName")}
          placeholder={"Il tuo nome"}
        />
      </InputWithLabel>
      <InputWithLabel label={"Cognome"}>
        <TextInput
          errorMessage={errors.lastName?.message}
          {...register("lastName")}
          placeholder={"Il tuo cognome"}
        />
      </InputWithLabel>
      <InputWithLabel
        subLabel={
          "Se si tratta di un rinnovo, inserisci l'email usata per l'iscrizione"
        }
        label={"Email"}
      >
        <TextInput
          errorMessage={errors.email?.message}
          {...register("email")}
          placeholder={"La tua email"}
        />
      </InputWithLabel>
      <div className={"flex flex-col space-y-1"}>
        <PrimaryButton
          loading={creatingPaymentIntent}
          label={"Ottieni informazioni"}
          onClick={handleSubmit(submitForm)}
        />
        <p className={"text-slate-500 text-sm"}>
          Spese e commissioni per bonifici esteri interamente a carico
          dell'ordinante
        </p>
      </div>
    </form>
  );
}
